import type { ErrorStatusType } from '@/app/types/error-layout';

export const ERROR_DATA: Record<
  ErrorStatusType,
  {
    title: string;
    description: string;
  }
> = {
  '404': {
    title: '404',
    description: 'ขออภัย ไม่พบหน้าที่คุณต้องการ',
  },
  '500': {
    title: '500',
    description: 'ขออภัย เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์',
  },
};
